module.exports = __webpack_public_path__ + "static/popup-fail-e545485d4f8ad51ef19d25f4222b8687.png";